import { useEffect } from "react";

export function useSeo({ title, description, path }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);
    }
    if (path) {
      let c = document.querySelector('link[rel="canonical"]');
      if (!c) {
        c = document.createElement("link");
        c.setAttribute("rel", "canonical");
        document.head.appendChild(c);
      }
      c.setAttribute("href", `https://losta.group${path}`);
    }
  }, [title, description, path]);
}
